function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

const maxRetries = 5;

export async function importWithRetry<T>(
  importFn: () => Promise<T>,
  retries = 0,
  interval = 1000
): Promise<T> {
  try {
    return await importFn();
  } catch (e) {
    const error = e as Error & { code?: string };

    if (error?.code === 'MODULE_NOT_FOUND') {
      throw e;
    }

    if (retries >= maxRetries) {
      throw e;
    }

    await wait(interval);
    console.warn(`Retrying to load a module. Retry number: ${retries + 1}`, e);
    return importWithRetry(importFn, retries + 1, interval);
  }
}

export async function importDateFnsLocales<T>(langCode: string): Promise<T> {
  return importWithRetry(() => import(`date-fns-locale/${langCode}.mjs`))
    .then(({ default: locale }) => locale)
    .catch((e) => {
      console.warn(`Locale (${langCode}) is not existing in date-fns: `, e);
    }) as Promise<T>;
}
